import { COLORS_THEME_WHITE } from "../../../../utils/constants";

export const INSIGHTS_TOP_CATEGORIES = 8;

// Net line stroke (verdigris) from the design.
export const NET_LINE_COLOR = COLORS_THEME_WHITE.primary;

// Opacity for out-of-selection (context) bars.
export const CONTEXT_BAR_OPACITY = 0.35;

// Trailing month window for the Monthly preset (matches the page's MONTH_WINDOW).
export const INSIGHTS_MONTH_WINDOW = 6;
